import { useMutation } from "@tanstack/react-query";

import api from "../../api";

const fetcher = api();

export default function useUpdateAgeGroupMutation(options = {}) {
  const {
    mutate: updateAgeGroup,
    isPending: isUpdateAgeGroupLoading,
    isError: updateAgeGroupError,
  } = useMutation({
    mutationFn: (data) => fetcher.updateCurriculumSettings(data),
    ...options,
  });

  return {
    updateAgeGroup,
    isUpdateAgeGroupLoading,
    updateAgeGroupError,
  };
}
